const calculateTotal = (items) => {
    let total = 0;
    let deliveryCost = 0;

    items.forEach(item => {
        if (!item.IsInStock || item.Product?.IsAvailable === false) return
        total += item.Price;
        // Например, добавим стоимость доставки как фиксированную цену для каждого товара
        deliveryCost += 500; // Поставка может иметь фиксированную стоимость, можно менять логику
    });

    return {
        total,
        deliveryCost,
        totalWithDelivery: total + deliveryCost,
    };
};
export { calculateTotal };
